<template>
  <div class="limite-seguradoras position-relative">

    <h5 v-if="titleComponent">
      <div class="form-subheader">
        <span>{{ titleComponent }}</span>
      </div>
    </h5>
      
    <div class="overlay" v-if="loading" >
      <div class="d-flex align-items-center justify-content-center mb-2">
        <b-spinner label="Loading..."></b-spinner>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12">
        <div class="d-flex mb-2 align-items-start justify-content-end">
          <label class="dbo-ui mb-lg-0 font-weight-bold mr-auto">SEGURADORAS</label>
          <a
            @click="$bvModal.show('show-modal-update-limit'+index)"
            class="button btn btn-outline-secondary btn-sm mr-1">
            <i class="fa fa-arrows-rotate mr-1"></i> Buscar limites
          </a>
        </div>
      </div>
      
      <div class="col-12">
        
        <b-tabs v-if="getInsurers.length">
          <b-tab v-for="(listLimitsInsurer, insurerIdentifier) in listInsurers" :key="insurerIdentifier"
            class="tab-content border-left border-bottom border-right p-4 mb-3"
            title-link-class="py-3">
            <template #title>
              <img :src="listLimitsInsurer[0].insurer.icon" :alt="listLimitsInsurer[0].insurer.name"
                class="object-fit-contain" style="height: 25px; max-width: 100px; object-position: center center;">
            </template>
            
            <div class="table-responsive table-limits-holder">
              <b-table
                class="table pretty font-14 m-0 no-wrap"
                :items="listLimitsInsurer"
                :fields="fieldsListLimits"
              >
              
                <template #cell(modality_name)="data">
                  <span>{{ data.item.modality_name }}</span><br>
                  <small>{{ data.item.observation }}</small>
                </template>
                <template #cell(tax)="data">
                  <span class="centered-cell break-line">{{ formatPercentage(data.value) }}</span>
                </template>
                <template #cell(limit_available)="data">
                  <span class="centered-cell break-line">{{ formatCurrency(data.value) }}</span>
                </template>
                <template #cell(limit_total)="data">
                  <span class="centered-cell break-line">{{ data.value ? formatCurrency(data.value) : '-' }}</span>
                </template>
                <template #cell(updated_at)="data">
                  <span class="centered-cell break-line">{{ formatDateTimeCustom(data.value) }}</span>
                </template>
                
              </b-table>
            </div>

            <small>
              <i class="fa fa-asterisk text-warning mr-1"></i>
              Os saldos de limite utilizado e limite disponível exibidos nesta página são informados pelas seguradoras parceiras, por meio de suas APIs.
            </small>

          </b-tab>
        </b-tabs>

        <small v-else>Nenhum limite cadastrado.</small>
        

      </div>
    </div>
    
    <div class="modal">
      <b-modal
        :id="'show-modal-limit-holder-list-'+  index "
        ref="showModalLimitHolderList"
        size="xl"
        class="mt-4"
        hide-footer
      >
        <template #modal-title>
          <h5 class="modal-title">Lista de limites:</h5>
        </template>

        <p v-if="index>=0"><strong>{{ economicGroup.group_name }}</strong></p>
    
        <div class="table-responsive">
          <b-table
            class="table-v3 custom-table custom-table-quotation no-wrap"
            sticky-header
            no-border-collapse
            :items="listLimits"
            :fields="fieldsListLimits"
          >
            <template #cell(modality_name)="data">
              <span>{{ data.item.modality_name }}</span><br>
              <small>{{ data.item.observation }}</small>
            </template>
            <template #cell(tax)="data">
              <span class="centered-cell break-line">{{ formatPercentage(data.value) }}</span>
            </template>
            <template #cell(limit_available)="data">
              <span class="centered-cell break-line">{{ formatCurrency(data.value) }}</span>
            </template>
            <template #cell(limit_total)="data">
              <span class="centered-cell break-line">{{ data.value ? formatCurrency(data.value) : '-' }}</span>
            </template>
            <template #cell(updated_at)="data">
              <span class="centered-cell break-line">{{ formatDateTimeCustom(data.value) }}</span>
            </template>
          </b-table>
        </div>
        
        <div class="flex mt-3">
            <div class="logo-seguradora-limite float-left"
              v-if="listLimits.length && icoInsurer"
              :style="{ backgroundImage: 'url(' + icoInsurer + ')' }"
            ></div>

            <div class="btn-group  float-right">
              <button class="btn btn-primary"
                :disabled="loadingUpdate" v-if="selectedInsurer"
                @click="updateLimiteInsurer()">
                
                <b-spinner v-if="loadingUpdate" class="spinner-border-sm float-right"></b-spinner>
                <span v-else>Buscar limites</span>
              </button>
              <button :disabled="loadingUpdate" class="btn btn-primary" @click="$refs.showModalLimitHolderList.hide();">Fechar</button>
            </div>
            
        </div>

      </b-modal>
      
      <UpdateLimitHolderModal :economicGroup="economicGroup" @getInsurerLimit="getInsurerLimit" :index="index" />
    </div>
  </div>
</template>

<script>
import UpdateLimitHolderModal from "@/components/Client/Modals/UpdateLimitHolderModal.vue";
import commomsHelperMixin from "@/mixins/commomsHelper";
import numericFormatterMixin from "@/mixins/numericFormatter";
import dateFormatterMixin from "@/mixins/dateFormatter";
import companyService from "@/services/company";
export default {
  name: 'MarketCapacity',
  mixins: [commomsHelperMixin, numericFormatterMixin, dateFormatterMixin],
  components: { UpdateLimitHolderModal },
  props: {
    titleComponent: {
      type: String,
      default: ''
    },
    economicGroup: {
      type: Object,
      required: true,
    },
    loadOnCreated: {
      type: Boolean,
      default: true
    },
    index: Number,
  },
  data: () => ({
    loading: true,
    selectedInsurer: null, 
    listLimits: [], 
    listInsurers: [],
    loadingUpdate: false,
    icoInsurer: null,
  }),
  created() {
    if (this.loadOnCreated) {
      this.getInsurerLimit();
    }
  },
  methods: {
    openModalListLimit(identifier) {
      this.selectedInsurer = identifier;
      this.listLimits = this.getModalitiesByInsurer(identifier);
      this.icoInsurer = this.listLimits[0].insurer.icon;
      this.$bvModal.show("show-modal-limit-holder-list-" + this.index);
    },
    getModalitiesByInsurer(insurer) {
      return this.listInsurers[insurer] || [];
    },
    getInsurerLimit() {
      this.loading = true;
      this.$emit('changeLoading', true);
      companyService
        .getInsurerLimit(this.economicGroup.id)
        .then((response) => {
          if (response.data.error || response.data.length===0) {
            return {};
          }
          this.listInsurers = response.data;
        })
        .catch(() => {
          this.showError(
            "Não foi possível buscar os limites das seguradoras."
          );
        })
        .finally(() => {
          this.loading = false;
          this.$emit('changeLoading', false);
        });
    },
    updateLimiteInsurer() {
      this.loadingUpdate = true;
      companyService.updateLimitEconomicGroup(this.economicGroup.id, this.selectedInsurer)
          .then((response) => {
            if (response.data.error) {
              return;
            }
            this.listLimits = response.data;
          })
          .finally(() => {
            this.loadingUpdate = false;
          });
    }
  },
  computed: {
    fieldsListLimits() {
      return [
        {
          key: "modality_name",
          label: "Modalidade",
          tdClass: "font-14",
          thClass: "text-left",
        },
        {
          key: "tax",
          label: "Taxa",
          tdClass: "font-14",
          thClass: "text-center",
        },
        {
          key: "limit_available",
          label: "Limite disponível",
          tdClass: "font-14",
          thClass: "text-center",
        },
        {
          key: "limit_total",
          label: "Limite Total",
          tdClass: "font-14",
          thClass: "text-center",
        },
        {
          key: "updated_at",
          label: "Última atualização",
          tdClass: "font-14",
          thClass: "text-center",
        },
      ];
    },
    getInsurers() {
      return Object.keys(this.listInsurers);
    },
  }
};
</script>

<style scoped>
::v-deep .table-responsive.table-limits-holder { max-height: 400px; overflow-y: auto !important; }
::v-deep .table-responsive.table-limits-holder table { border-collapse: separate; }
::v-deep .table-responsive.table-limits-holder table thead th { position: sticky !important; top: 0 !important; }
.form-subheader { background: none; }
.form-subheader > span { background: #fff; }
#show-modal-limit-holder-list .table td { padding: 0.25rem 0.75rem; }
#show-modal-limit-holder-list ul { margin-bottom: 0px; }
.overlay { position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; background-color: rgba(255, 255, 255, 0.7); z-index: 999; }
</style>